import React from "react";
import {makeStyles} from '@mui/styles';
import {useTranslation} from "react-i18next";
import {makeRequest, rolesState, tokenState} from "../../services/requestService";
import {ANONYMOUS_KEY, API_URL} from "../../constants";
import PasswordTextField from "../general/inputs/PasswordTextField";
import CaptchaDialogSlide from "../general/dialog/CaptchaDialogSlide";
import {useSetRecoilState} from "recoil";
import {useSnackbar} from "notistack";
import PropTypes from "prop-types";
import {Button, Container, Grid, Link, TextField, Typography} from "@mui/material";

const useStyles = makeStyles((theme) => ({
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(0, 0, 2),
    },
}));


export default function Login(props) {
    const {onClickRegister, onSuccess} = props;
    const classes = useStyles();
    const {t} = useTranslation('common');
    const {enqueueSnackbar} = useSnackbar();
    const setToken = useSetRecoilState(tokenState);
    const setRoles = useSetRecoilState(rolesState);
    const [username, setUsername] = React.useState("");
    const [password, setPassword] = React.useState("");
    const [saved, setSaved] = React.useState(false);
    const [captchaDialog, setCaptchaDialog] = React.useState(false);

    React.useEffect(() => {
        if (saved) {
            setSaved(false);
            enqueueSnackbar(t('main.components.auth.success'), {variant: "success"});
            onSuccess();
        }
    }, [saved, enqueueSnackbar, t, onSuccess]);

    const onChangeUsername = (e) => {
        const username = e.target.value;
        setUsername(username);
    };

    const onChangePassword = (e) => {
        const password = e.target.value;
        setPassword(password);
    };

    const handleLogin = (e) => {
        e.preventDefault();
        makeRequest(`${API_URL}/auth/login`, 'POST', {username, password}).then((response) => {
            if (response.status === 200) {
                setToken(response.data.token);
                setRoles(response.data.roles);
                setSaved(true);
            }
        });
    }

    const toggleCaptchaDialog = () => {
        setCaptchaDialog(!captchaDialog);
    }

    const handleAnonymousLogin = (captchaValue) => {
        toggleCaptchaDialog();
        if (captchaValue)
            makeRequest(
                `${API_URL}/auth/anonymous`,
                'POST',
                ANONYMOUS_KEY,
                {
                    'Content-Type': 'text/plain',
                    'X-Recaptcha-Key': captchaValue,
                }).then((response) => {
                if (response.status === 200) {
                    setToken(response.data.token);
                    setRoles(response.data.roles);
                    setSaved(true);
                }
            });
    }

    const goToRegister = (e) => {
        e.preventDefault();
        onClickRegister();
    }

    return (
        <Container component="main" maxWidth="xs">
            <div className={classes.paper}>
                <Typography component="h1" variant="h5">
                    {t('main.components.auth.login')}
                </Typography>
                <form onSubmit={handleLogin} className={classes.form} noValidate>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                color="secondary"
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="username"
                                label={t('main.components.form.placeholder.username')}
                                name="username"
                                value={username}
                                onChange={onChangeUsername}
                                autoFocus
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <PasswordTextField
                                label={t('main.components.form.placeholder.password')}
                                value={password}
                                onChange={onChangePassword}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                            >
                                {t('main.components.button.login')}
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                                onClick={toggleCaptchaDialog}
                            >
                                {t('main.components.button.anonymous')}
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs>
                                    {/*<Link href="" variant="body2" color="textSecondary">
                                {t('main.components.auth.forgotPassword')}
                            </Link>*/}
                                </Grid>
                                <Grid item>
                                    <Link href="#" onClick={goToRegister} variant={"body2"} color="textSecondary">
                                        {t('main.components.auth.noAccount')}
                                    </Link>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
                <CaptchaDialogSlide
                    open={captchaDialog}
                    handleClose={toggleCaptchaDialog}
                    validateCaptcha={handleAnonymousLogin}
                    title={t("main.components.captchaDialog.title")}
                    description={t("main.components.captchaDialog.description")}
                />
            </div>
        </Container>
    );
}

Login.propTypes = {
    onClickRegister: PropTypes.func,
    onSuccess: PropTypes.func.isRequired
}

Login.defaultProps = {
    onClickRegister: () => {
        console.warn("You didn't initiate the props \"onClickRegister\"");
    }
}
